/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

import { inject, Injectable, type Signal }                                               from "@angular/core";
import { toSignal }                                                                      from "@angular/core/rxjs-interop";
import { type User }                                                                     from "@angular/fire/auth";
import { collection, collectionData, type CollectionReference, Firestore, query, where } from "@angular/fire/firestore";
import { type StripePaymentMethodDocument }                                              from "@bowstring/interfaces";
import { catchError, Observable, of, switchMap }                                         from "rxjs";
import { AuthenticationService }                                                         from "./AuthenticationService";
import { RxSsrService }                                                                  from "./RxSsrService";


@Injectable({ providedIn: "root" })
export class StripePaymentMethodsService {

  private readonly authenticationService: AuthenticationService = inject<AuthenticationService>(AuthenticationService);
  private readonly firestore: Firestore                         = inject<Firestore>(Firestore);
  private readonly rxSsrService: RxSsrService                   = inject<RxSsrService>(RxSsrService);

  public readonly stripePaymentMethodDocuments$: Signal<Array<StripePaymentMethodDocument> | undefined> = toSignal<Array<StripePaymentMethodDocument> | undefined>(
    this.authenticationService.userObservable.pipe<Array<StripePaymentMethodDocument> | undefined>(
      this.rxSsrService.wrap<User, Array<StripePaymentMethodDocument> | undefined>(
        switchMap<User, Observable<Array<StripePaymentMethodDocument> | undefined>>(
          ({ uid: userId }: User): Observable<Array<StripePaymentMethodDocument> | undefined> => collectionData<StripePaymentMethodDocument>(
            query<StripePaymentMethodDocument, StripePaymentMethodDocument>(
              collection(
                this.firestore,
                "stripePaymentMethods",
              ) as CollectionReference<StripePaymentMethodDocument, StripePaymentMethodDocument>,
              where(
                "userId",
                "==",
                userId,
              ),
            ),
          ).pipe<Array<StripePaymentMethodDocument> | undefined>(
            catchError<Array<StripePaymentMethodDocument>, Observable<undefined>>(
              (): Observable<undefined> => of<undefined>(undefined),
            ),
          ),
        ),
        "01967434-f45e-758c-9541-d9a290c977c5",
      ),
    ),
  );

}
